import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import EntrySection from "./components/EntrySection";
import AddressSection from "./components/AddressSection";
import AppSection from "./components/AppSection";
import AccessSection from "./components/AccessSection";
import FeatureSection from "./components/FeatureSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import SecuritySection from "./components/SecuritySection";
import UpdatesSection from "./components/UpdatesSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <EntrySection />
        <AddressSection />
        <AppSection />
        <AccessSection />
        <FeatureSection />
        <GuideSection />
        <FaqSection />
        <SecuritySection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}